import { render, staticRenderFns } from "./etablissement-designer-directeur.vue?vue&type=template&id=00ca71cc"
import script from "./etablissement-designer-directeur.vue?vue&type=script&lang=js"
export * from "./etablissement-designer-directeur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports